import styled from 'styled-components/native'
import { Pressable } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'
import { Input } from 'react-native-elements'
import Typography from 'APP/Converse/Typography'
import Button from 'APP/Converse/Button'

const MODAL_WIDTH = 640

export const WebContainer = styled.View`
  flex: 1;
  justify-content: center;
  align-items: center;
`

export const WebBackdrop = styled(Pressable)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(26, 26, 26, 0.75);
`

export const WebContentWrapper = styled.View`
  position: absolute;
  width: 90%;
  max-width: ${MODAL_WIDTH}px;
  height: calc(100% - ${({ theme }) => theme.metrics.baseMargin * 4}px);
`

export const MobileFullScreenContainer = styled.View`
  flex: 1;
  background-color: ${({ theme }) => theme.colors.elementsBg};
`

export const StyledSafeAreaView = styled(SafeAreaView)`
  flex: 1;
`

export const StyledView = styled.View`
  flex: 1;
  padding: ${({ theme }) => theme.metrics.baseMargin * 2}px;
  padding-left: ${({ theme }) => theme.metrics.baseMargin * 1.25}px;
  justify-content: center;
  align-items: center;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.elementsBg};
  shadow: ${({ theme }) => (theme.isBigScreen ? theme.shadows.normal : 'none')};
  border-top-left-radius: ${({ theme }) => theme.metrics.borderRadius.medium}px;
  border-top-right-radius: ${({ theme }) => theme.metrics.borderRadius.medium}px;
  border-bottom-left-radius: ${({ theme }) =>
    theme.isBigScreen ? theme.metrics.borderRadius.medium : '0px'};
  border-bottom-right-radius: ${({ theme }) =>
    theme.isBigScreen ? theme.metrics.borderRadius.medium : '0px'};
`

export const StyledClose = styled.TouchableOpacity`
  width: ${({ theme }) => theme.metrics.icon.large}px;
  height: ${({ theme }) => theme.metrics.icon.large}px;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  border: 1px solid ${({ theme }) => theme.colors.elementsBorder};
`

export const StyledElementsWrapper = styled.View`
  flex-direction: row;
  width: 100%;
`

export const StyledInputWrapper = styled.View`
  flex: 1;
`

export const StyledInput = styled(Input)`
  border: 1px solid ${({ theme }) => theme.colors.elementsBorder};
  padding: 0px ${({ theme }) => theme.metrics.baseMargin}px;
  border-radius: 100px;
  font-size: ${({ theme }) => theme.fonts.fontSize.regular}px;
`

export const StyledSearchResults = styled.View`
  display: flex;
  justify-content: flex-start;
  align-self: center;
  flex: 1;
  width: 100%;
`

export const StyledSearchText = styled(Typography)`
  text-align: center;
  color: ${({ theme }) => theme.colors.textSecondary};
  margin-bottom: ${({ theme }) => theme.metrics.baseMargin * 2}px;
`

export const StyledButton = styled(Button)`
  align-self: center;
`

export const StyledSearchWrapper = styled.View`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: ${({ theme }) => theme.metrics.baseMargin * 4}px;
  gap: ${({ theme }) => theme.metrics.baseMargin / 2}px;
`

export const StyledLoadingView = styled.View`
  border-bottom-width: 1px;
  border-bottom-color: ${({ theme }) => theme.colors.elementsBorder};
  padding-horizontal: ${({ theme }) => theme.metrics.baseMargin * 1.5}px;
  padding-vertical: ${({ theme }) => theme.metrics.baseMargin}px;
  gap: ${({ theme }) => theme.metrics.baseMargin / 4}px;
`
